import { ProductListItem } from '@shared/model/product';

export const pageTitleType = (product: ProductListItem | undefined) => {
    const code = product?.type.code;
    switch (code) {
        case 'course': {
            return 'курса';
        }
        case 'file': {
            return 'файла';
        }
        case 'license_key': {
            return 'лицензии';
        }
        case 'demo': {
            return 'демо';
        }
        case 'offline_meeting': {
            return 'мероприятия';
        }
        case 'online_meeting': {
            return 'вебинара';
        }
        default: {
            return 'продукта';
        }
    }
};
